(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hoj-story-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  function show(root, go, focusTab) {
    var tabs = root.querySelectorAll('[data-hoj-tab]');
    var panels = root.querySelectorAll('[data-hoj-panel]');
    for (var i = 0; i < panels.length; i++) { panels[i].hidden = i !== go; }
    for (var j = 0; j < tabs.length; j++) { tabs[j].setAttribute('aria-pressed', j === go ? 'true' : 'false'); }
    if (focusTab && tabs[go]) { tabs[go].focus(); }
  }
  document.addEventListener('click', function (e) {
    var root = e.target.closest && e.target.closest('[data-hoj-steps]');
    if (!root) return;
    var panels = root.querySelectorAll('[data-hoj-panel]');
    var cur = 0;
    for (var i = 0; i < panels.length; i++) { if (!panels[i].hidden) cur = i; }
    var tab = e.target.closest('[data-hoj-tab]');
    if (tab) { show(root, parseInt(tab.getAttribute('data-hoj-tab'), 10), false); return; }
    if (e.target.closest('[data-hoj-next]')) { show(root, (cur + 1) % panels.length, true); return; }
    if (e.target.closest('[data-hoj-prev]')) { show(root, Math.max(0, cur - 1), true); }
  });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest && e.target.closest('[data-hoj-tab]');
    if (tab) tab.click();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
